export default __webpack_public_path__ + "static/media/Agenda-Ferris-Wheel_rollover.143f179a.png";